import debounce from 'lodash/debounce';

const COLLAPSIBLE_AREA_BUTTON_DATA_ATTR = 'data-collapsible-area-button';
const BUTTON_TARGET_DATA_ATTR = 'data-collapsible-area-button-target';
const MIN_ROW_COUNT_DATA_ATTR = 'data-collapsible-area-min-rows-count';
const SHOW_MORE_TEXT_DATA_ATTR = 'data-collapsible-area-button-more';
const SHOW_LESS_TEXT_DATA_ATTR = 'data-collapsible-area-button-less';

export const initCollapsibleArea = () => {
  const showMoreButtonList = document.querySelectorAll(
    `[${COLLAPSIBLE_AREA_BUTTON_DATA_ATTR}]`
  );

  showMoreButtonList.forEach((button) => {
    updateListWithRelatedButton(button);

    button.addEventListener('click', (e) => {
      handleClickShowMoreButton(e);
    });
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      showMoreButtonList.forEach(updateListWithRelatedButton);
    }, 200)
  );
};

function updateListWithRelatedButton(targetButton) {
  const button = targetButton;
  const list = makeListOfShowMoreButton(button);
  const isVisibleShowMoreButton = isVisibleShowButtonByList(list);

  button.style.display = isVisibleShowMoreButton ? 'block' : 'none';
  button.style.visibility = isVisibleShowMoreButton ? 'visible' : 'hidden';

  if (isVisibleShowMoreButton) {
    collapseList(list);
  }
}

function handleClickShowMoreButton(event) {
  const targetButton = event.target;

  const list = makeListOfShowMoreButton(targetButton);

  const isListExpanded =
    list.children[list.children.length - 1].offsetTop <
    Number.parseInt(list.style.maxHeight, 10);

  const showMoreText = targetButton.getAttribute(SHOW_MORE_TEXT_DATA_ATTR);
  const showLessText = targetButton.getAttribute(SHOW_LESS_TEXT_DATA_ATTR);

  if (isListExpanded) {
    targetButton.innerHTML = showMoreText;
    targetButton.setAttribute('aria-label', showMoreText);
    collapseList(list);
  } else {
    targetButton.innerHTML = showLessText;
    targetButton.setAttribute('aria-label', showLessText);
    expandList(list);
  }
}

function isVisibleShowButtonByList(list) {
  const allBlocksCount = list.children.length;

  if (!allBlocksCount) {
    return false;
  }

  const blocksCountPerLine = calcBlocksCountPerLine(list.children);
  const minBlocksShownCount =
    blocksCountPerLine * list.getAttribute(MIN_ROW_COUNT_DATA_ATTR) || 0;
  const hasHiddenRowsByList = allBlocksCount > minBlocksShownCount;

  if (!hasHiddenRowsByList) {
    return false;
  }

  const visibleRowsCount = Math.ceil(minBlocksShownCount / blocksCountPerLine);
  const allRowsCount = Math.ceil(allBlocksCount / blocksCountPerLine);

  return visibleRowsCount < allRowsCount;
}

function makeListOfShowMoreButton(showMoreButton) {
  return document.querySelector(
    `[${showMoreButton.getAttribute(BUTTON_TARGET_DATA_ATTR)}]`
  );
}

function collapseList(list) {
  const minVisibleCount =
    calcBlocksCountPerLine(list.children) *
      list.getAttribute(MIN_ROW_COUNT_DATA_ATTR) || 0;
  const lastVisibleItem = list.children[minVisibleCount - 1] || null;

  const listCollapsedHeight = calcRowHeightByItem(lastVisibleItem);

  list.style.maxHeight = `${listCollapsedHeight}px`;

  Array.from(list.children).forEach((block) => {
    if (!lastVisibleItem) {
      block.tabIndex = -1;
    } else if (block.offsetTop > lastVisibleItem.offsetTop) {
      block.tabIndex = -1;
    }
  });
}

function expandList(list) {
  const lastListItem = list.children[list.children.length - 1];
  const listFullHeight = calcRowHeightByItem(lastListItem);

  list.style.maxHeight = `${listFullHeight}px`;

  Array.from(list.children).forEach((block) => {
    block.tabIndex = 0;
  });
}

function calcBlocksCountPerLine(listBlocks) {
  const offsetOfFirstBlock = listBlocks[0].offsetTop;
  let itemsPerRow = 1;

  for (let i = 0; i < listBlocks.length; i += 1) {
    if (offsetOfFirstBlock !== listBlocks[i].offsetTop) {
      itemsPerRow = i;
      break;
    }
  }

  return itemsPerRow;
}

function calcRowHeightByItem(item) {
  if (!item) {
    return 0;
  }

  return item.offsetTop + item.clientHeight;
}
